// removed by extract-text-webpack-plugin
module.exports = {"Wrap":"cJ46AGwbAx8Lm2jwnUBMl","IsDrag":"_1pio7oeubuDpGVvWgYTVGO","Icon":"ax8-WTXN-AWHRV44SnwQl"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryDADUpload/styles.module.css
// module id = 573
// module chunks = 0